/** hex -> rgb
 * @param {Object} hex
 */
function hexToRgb (hex) {
  return 'rgb(' + parseInt('0x' + hex.slice(1, 3)) + ',' + parseInt('0x' + hex.slice(3, 5)) +
          ',' + parseInt('0x' + hex.slice(5, 7)) + ')'
}

/** hex -> rgba
 * @param {Object} hex
 * @param {Object} alpha
 */
function hexToRgba (hex, alpha) {
  return 'rgba(' + parseInt('0x' + hex.slice(1, 3)) + ',' + parseInt('0x' + hex.slice(3, 5)) + ',' +
          parseInt('0x' + hex.slice(5, 7)) + ',' + alpha + ')'
}

export default {
  hexToRgb: hexToRgb,
  hexToRgba: hexToRgba
}
